import Table from "@/common/components/Table";
import { Mapper } from "@/common/services/mapper";
import { TrackerIntegrationData, TrackerIntegrationTableItem } from "../../../types/trackerIntegration.type";
import { defaultColumns } from "../../../constants/companyTrackerIntegrationsColumns.constant";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { useTrackerIntegrations } from "@/common/hooks/queries/useTrackerIntegrations";
import { TrackerIntegrationsTransformer } from "../../../services/trackerIntegrations/trackerIntegrationsTransformer";
import { Link, useParams } from "react-router-dom";
import Button from "@/common/components/Button";
import Box from "@/common/components/Box";
import LoadingSpinner from "@/common/components/LoadingSpinner";

const TrackerIntegrations = () => {
  const { id } = useParams();

  const { filterParams, setFilterParams } = useFilterParams();

  const {
    data: trackerIntegrations,
    meta,
    isPending: isPendingTrackerIntegrations,
    isFetching: isFetchingTrackerIntegrations,
    isLoading: isLoadingTrackerIntegrations,
    error: trackerIntegrationsError = {} as any,
    refetch: refetchTrackerIntegrations,
  } = useTrackerIntegrations({
    filters: {
      page: filterParams.page || 1,
      companyId: id
    },
    mapper: Mapper.mapWithTransformer<TrackerIntegrationData[], TrackerIntegrationTableItem[]>({
      transformer: TrackerIntegrationsTransformer.tableTransformer(id || '')
    }),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={trackerIntegrationsError?.status}
      refetchFunction={refetchTrackerIntegrations}
    >
      <Box className='flex flex-col gap-6 overflow-y-auto'>
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <p className="text-lg font-bold">Integrações de rastreamento</p>

            <div className="flex gap-2">
              <LoadingSpinner isLoading={isFetchingTrackerIntegrations} />
              <Link
                to={isPendingTrackerIntegrations ? '' : `/companies/${id}/tracker-integrations/create`}
                className={isPendingTrackerIntegrations ? 'cursor-default' : ''}
                >
                <Button
                  className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
                  data-testid="create_company_tracker_integration"
                  disabled={isPendingTrackerIntegrations}
                  operationKlassToCheckPermission="Admin::Client::TrackerIntegrations::Create"
                  >
                  Nova integração
                </Button>
              </Link>
            </div>
          </div>

          <Table
            className="max-h-[calc(100vh-324px)]"
            columns={defaultColumns}
            isLoadingData={isLoadingTrackerIntegrations}
            page={filterParams.page || 1}
            rows={trackerIntegrations}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </Box>
    </ErrorMessageWrapper>
  );
};

export default TrackerIntegrations;
